import styled from 'styled-components'
import { tabletSize } from '../screen-sizes'

export const LightTitle = styled.span`
  font-size: 4.2rem;
  font-family: 'Montserrat-Light';
  @media (max-width: ${tabletSize}) {
    font-size: 2.6rem;
  }
`
export const SubLightTitle = styled.span`
  font-size: 3.2rem;
  font-family: 'Montserrat-Light';
  @media (max-width: ${tabletSize}) {
    font-size: 2.2rem;
  }
`

export const FatTitle = styled.span`
  font-size: 4.2rem;
  font-family: 'Montserrat';

  @media (max-width: ${tabletSize}) {
    font-size: 2.6rem;
  }
`
